import { Directive, ElementRef, HostBinding, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({ selector: '[draggable]' })
export class DraggableDirective {
	@Input('draggable') handleSelector?: string;

	@HostBinding('class.dragged')
	private wasDragged = false;
	@HostBinding('style.left.px') private offsetLeft?: number;
	@HostBinding('style.top.px') private offsetTop?: number;
	@HostBinding('style.position') private position?: string;
	private dragging?: DragInfo;
	private element: HTMLElement;
	private globalListenFunc: Function | undefined;

	constructor(element: ElementRef<HTMLElement>, private renderer: Renderer2) {
		this.element = element.nativeElement;
	}

	@HostListener('mousedown', ['$event.clientX', '$event.clientY', '$event.button', '$event.target']) onMouseDown(x: number, y: number, mouseButton: number, target: Node) {
		let handle = this.handleSelector
			? this.element.querySelector(this.handleSelector)
			: this.element;

		this.globalListenFunc = this.renderer.listen('document', 'mousemove', e => {
			this.mouseMove(e.clientX, e.clientY);
		});

		if (!handle || !handle.contains(target) || mouseButton !== 0) return;

		let position = this.element.getBoundingClientRect();
		this.dragging = new DragInfo(x, y, position.left, position.top);
	}

	mouseMove(x: number, y: number) {
		if (!this.dragging) {
			if (this.globalListenFunc)
				this.globalListenFunc();
			return;
		}

		let deltaX = x - this.dragging.originX;
		let deltaY = y - this.dragging.originY;

		this.position = 'fixed';
		this.offsetLeft = this.dragging.offsetX + deltaX;
		this.offsetTop = this.dragging.offsetY + deltaY;
		this.wasDragged = true;
	}
	@HostListener('document:mouseup', ['$event.button']) onMouseUp(mouseButton: number) {
		if (!this.dragging || mouseButton !== 0) return;
		if (this.globalListenFunc)
			this.globalListenFunc();
		this.dragging = undefined;
	}
}

class DragInfo {
	constructor(public originX: number, public originY: number, public offsetX: number, public offsetY: number) {
	}
}
